(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairBoothTableBookedController', PhysicalFairBoothTableBookedController);
    PhysicalFairBoothTableBookedController.$inject = ['$uibModal', 'ExpoService', 'CitiesByExpoService', 'PhysicalFairService'];
    function PhysicalFairBoothTableBookedController($uibModal, ExpoService, CitiesByExpoService, PhysicalFairService) {
        var vm = this;

        vm.flag                  = false;
        vm.expos                 = [];
        vm.expoSelected          = -1;
        vm.semesterSelected      = -1;
        vm.selectExpoBySemester  = selectExpoBySemester;
        vm.selectSemester        = selectSemester;
        vm.semester              = [];
        vm.getByFilter           = getByFilter;
        vm.getByFilterCsv        = getByFilterCsv;

        /*PAGINATION*/
        vm.pageChanged           = pageChanged;
        vm.setPage               = setPage;
        vm.to                    = [];
        vm.totalItems            = [];
        vm.currentPage           = null;
        vm.itemsPerPage          = [];
        vm.page                  = 1;

        function activate() {
            vm.selectSemester();
        }

        function selectExpoBySemester () {
            let query = {};
            query['semester'] = vm.semesterSelected;
            ExpoService.getExpoBySemester(query).then(function(response){
                 vm.expo = [];
                 vm.expo = response.data;
                 vm.expo.unshift({id: -1, name: '-- All --'})
                 vm.expoSelected = -1;
            });
        }

        function selectSemester () {
            ExpoService.getSemesters().then(function(response){
                vm.semester = response.data;
            });
        }

        function getByFilter() {
            vm.flag = false;
            let query = {};
            if (vm.expoSelected !== -1) {
                query['expo_id'] = vm.expoSelected;
            }
            if (vm.semesterSelected !== -1) {
                query['semester'] = vm.semesterSelected;
            }
            if (vm.page !== null) {
                query['page'] = vm.page;
            }
            PhysicalFairService.getByFilterBoothTableBooked(query).then(function(response){
                vm.expos = response.data.data;
                vm.flag = true;
                if(vm.expos.length == 0){
                    vm.noResultMessage = 'Sorry, no results were found!';
                    vm.flag = false;
                } else {
                    vm.noResultMessage = '';
                    vm.flag = true;
                }
                vm.totalItems = response.data.total;
                vm.to         = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
            });
        }

        function getByFilterCsv () {
            let query = {};
            if (vm.expoSelected !== -1) {
                query['expo_id'] = vm.expoSelected;
            }
            if (vm.semesterSelected !== -1) {
                query['semester'] = vm.semesterSelected;
            }

            PhysicalFairService.getByFilterBoothTableBookedCSV(query).success(function(data) {
                var anchor = document.createElement('a');
                var file_name = 'physical_table_booked_' + vm.semesterSelected;
                if (vm.expoSelected !== -1) {
                    file_name = file_name + '_' + vm.expoSelected;
                }
                file_name = file_name + '.csv';

                var anchor = document.createElement("a");
                anchor.href = "data:application/octet-stream;base64," + encodeURI(data);
                anchor.target = "_blank";
                anchor.download = file_name;
                document.body.appendChild(anchor);
                anchor.click();
                $timeout(function () {
                anchor.remove();
                }, 50);
            });
        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }
        activate();
    }
})();